import * as React from 'react'
import { forwardRef, useCallback, useContext, useEffect, useReducer, useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import GridContainer from '../grid/GridContainer'
import GridItem from '../grid/GridItem'
import CustomInput from '../input/CustomInput'
import Button from '../button/RegularButton'
import RegularButton from '../button/RegularButton'
import axios from 'axios'
import { apiUrl, timeout, UserContext } from '../../App'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import styles from '../../assets/jss/dorm-app/customSelectStyle.js'

import { initialNotificationState } from '../utils/state/ApplicationState'
import MaterialTable from 'material-table'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import Card from '../card/Card'
import CardHeader from '../card/CardHeader'
import CardBody from '../card/CardBody'
import Container from '@material-ui/core/Container'
import { AddAlert, Close } from '@material-ui/icons'
import Snackbar from '../snackbar/Snackbar'
import download from 'downloadjs'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
import { getApiUrl } from '../../api/api'

const useStyles = makeStyles(styles)

const columns = [
  { title: 'Referat', field: 'department', width: '10%' },
  { title: 'Semester', field: 'semester', width: '10%' },
  {
    title: 'Motivation',
    field: 'motivation',
    width: '80%',
    render: (rowData) => <span style={{ whiteSpace: 'pre-line' }}> {rowData.motivation} </span>,
  },
]

function stateReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }

    case 'success':
      return {
        ...initialState,
      }

    default:
      break
  }
  return state
}

const initialState = {
  department: '',
  semester: 'WS24/25',
  tenantId: '',
  motivation: '',
}

const departments = {
  "AA": "Aufnahmereferat",
  "AaNach": "Aufnahmereferat-Nachrücker",
  "Automat": "Automatenreferat",
  "Bar": "Barreferat",
  "BarFinanzen": "Barreferat (Finanzen)",
  "BarTechnik": "Barreferat (Technik)",
  "Billiard": "Spielereferat",
  "Chor": "Chor",
  "Computer": "Computerreferat",
  "Finanzen": "Finanzenreferat",
  "Heimrat": "Heimrat",
  "HsvVertreter": "HSV-Vertreter",
  "Info": "Inforeferat",
  "Innen": "Innenreferat",
  "Kreativreferat": "Kreativreferat",
  "Kultur": "Kulturreferat",
  "Multimedia": "Multimediareferat",
  "Nachhaltigkeit": 'Nachhaltigkeitsreferat (Nachhaltigkeit)',
  "NachhaltigkeitHochbeete": 'Nachhaltigkeitsreferat (Hochbeete)',
  "Netzwerk": "Netzwerkreferat",
  "PR": "PR-Referat",
  "Revisor": "Revisoren",
  "Schlichtung": "Schlichtungsreferat",
  "SportFitness": "Sportreferat (Fitness)",
  "SportFussball": "Sportreferat (Fußball)",
  "SportVolleyball": "Sportreferat (Volleyball)",
  "Tafel": "Tafelreferat",
  "Tutoren": "Tutoren",
  "WaMaLaufer": "Waschmaschinenreferat (Läufer)",
  "WaMaTechnik": "Waschmaschinenreferat (Technik)",
  "WMarken": "Waschmarkenverkäufer",
  "Werk": "Werkreferat",
  "Zimmer": "Zimmerreferat",
  "Zeitung": "Zeitungreferat"
}

const Transition = forwardRef(function transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

export default function IndividualEngagementApplication() {
  const classes = useStyles()
  const { user } = useContext(UserContext)

  const [proceeding, setProceeding] = useState(true)
  const [state, dispatch] = useReducer(stateReducer, initialState)
  const [applications, setApplications] = useState([])
  const imageInputField = useRef(null)
  const [image, setImage] = useState(null)
  const [applicationId, setApplicationId] = useState(null)
  const [modal, setModal] = useState(false)

  const [notification, setNotification] = useState(initialNotificationState)

  const fetchApplications = useCallback(() => {
    getApiUrl()
      .get(`/individual/engagements/applications`)
      .then(function(response) {
        setProceeding(false)
        setApplications(response.data)
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [])

  const downloadImage = (rowData) => {
    axios
      .get(`${apiUrl}/individual/engagements/applications/${rowData.applicationId}/image`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
          'X-Smartdorm-Dorm-ID': '4885b6d1-bbe4-4d40-bd24-bce33f0d7728',
        },
        responseType: 'blob',
      })
      .then((response) => {
        const content = response.headers['content-type']
        const fileName = response.headers['x-file-name']
        download(response.data, fileName, content)
      })
      .catch((error) => console.log(error))
  }

  const deleteAction = () => {
    setModal(false)

    getApiUrl()
      .delete(`/individual/engagements/applications/${applicationId}`)
      .then(function() {
        fetchApplications()
        setNotification({
          open: true,
          message: 'Bewerbung wurde gelöscht.',
          color: 'success',
        })
      })
      .catch(function(error) {
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  useEffect(() => {
    setProceeding(true)
    fetchApplications()
  }, [fetchApplications])

  let validFileExtensions = ['jpg', 'jpeg', 'bmp', 'gif', 'png']

  function validateImage(filesInput) {
    let tmp = filesInput[0]
    if (tmp != null) {
      let fileExtension = tmp.name.split('.')[1].toLowerCase()
      let size = tmp.size

      if (validFileExtensions.indexOf(fileExtension) === -1) {
        setNotification({
          open: true,
          message: 'Nur Bilder im Format \'jpg\', \'jpeg\', \'bmp\', \'gif\', \'png\' dürfen hochgeladen werden.',
          color: 'danger',
        })
        return false
      }

      if (size > 6 * Math.pow(10, 6)) {
        setNotification({
          open: true,
          message: 'Das Bild darf nicht größer 6MB sein.',
          color: 'danger',
        })
        return false
      }
      return true
    }
    return false
  }

  const submitForm = (e) => {
    e.preventDefault()
    let formData = new FormData()

    formData.append('image', image)
    formData.append(
      'request',
      new Blob([JSON.stringify({ ...state, tenantId: user.id })], {
        type: 'application/json',
      }),
    )

    // // Uncomment it when no applications are proceeded
    // setNotification({
    //   open: true,
    //   message: 'Bewerbungsfrist ist abgelaufen. Bei Fragen bitte kontaktiere die Heimräte heimrat@schollheim.net',
    //   color: 'danger',
    // })


    // Uncomment it when applications are proceeded
    getApiUrl()
      .post(`/individual/engagements/applications`, formData)
      .then(function() {
        fetchApplications()
        dispatch({ type: 'success' })
        setNotification({
          open: true,
          message: 'Bewerbung hinzugefügt',
          color: 'success',
        })
      })
      .catch(function(error) {
        dispatch({ type: 'error' })
        setNotification({
          open: true,
          message: `${error.response?.data?.message}`,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <div className={classes.container}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Bewerbung</h4>
            </CardHeader>
            <CardBody>
              <Container component="main" maxWidth="md">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={9}>
                    <FormControl fullWidth className={classes.selectFormControl}>
                      <InputLabel htmlFor="department" className={classes.selectLabel}>
                        Referat
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        value={state.department}
                        onChange={(e) => {
                          dispatch({
                            type: 'field',
                            field: 'department',
                            value: e.currentTarget.getAttribute('data-value'),
                          })
                        }}
                        inputProps={{
                          name: 'department',
                          id: 'department',
                        }}>
                        {departments
                          ? Object.entries(departments).map(([key, value]) => (
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value={key}>
                              {value}
                            </MenuItem>
                          ))
                          : []}
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Semester"
                      id="semester"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: state.semester,
                        type: 'text',
                        onChange: (e) =>
                          dispatch({
                            type: 'field',
                            field: 'semester',
                            value: e.currentTarget.value,
                          }),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Motivation"
                      id="motivation"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: state.motivation,
                        type: 'text',
                        multiline: true,
                        rows: 10,
                        onChange: (e) =>
                          dispatch({
                            type: 'field',
                            field: 'motivation',
                            value: e.currentTarget.value,
                          }),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <br/>
                    <p style={{ margin: ' 0 0 -35px' }}>Optionales Bild von Dir</p>
                    <CustomInput
                      labelText=""
                      id="picture"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: 'file',
                        ref: imageInputField,
                        onChange: (e) => {
                          const { files: newFiles } = e.target
                          if (validateImage(newFiles)) {
                            setImage(e.target.files[0])
                          } else {
                            e.target.value = null
                          }
                        },
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <br/>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button
                      color="primary"
                      onClick={(e) => {
                        submitForm(e)
                      }}>
                      Abschicken
                    </Button>
                  </GridItem>
                </GridContainer>
              </Container>
            </CardBody>
          </Card>
        </GridItem>
        <Dialog
          classes={{
            root: classes.center + ' ' + classes.modalRoot,
            paper: classes.modal + ' ' + classes.modalSmall,
          }}
          open={modal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setModal(false)}
          aria-labelledby="small-modal-slide-title"
          aria-describedby="small-modal-slide-description">
          <DialogTitle id="small-modal-slide-title" disableTypography className={classes.modalHeader}>
            <RegularButton
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => setModal(false)}>
              <Close className={classes.modalClose}/>
            </RegularButton>
          </DialogTitle>
          <DialogContent
            id="small-modal-slide-description"
            className={classes.modalBody + ' ' + classes.modalSmallBody}>
            <h5>Willst du die Bewerbung löschen?</h5>
          </DialogContent>
          <DialogActions className={classes.modalFooter + ' ' + classes.modalFooterCenter}>
            <RegularButton
              onClick={() => setModal(false)}
              color="transparent"
              className={classes.modalSmallFooterFirstButton}>
              Zurück
            </RegularButton>
            <RegularButton
              onClick={deleteAction}
              color="success"
              simple
              className={classes.modalSmallFooterFirstButton + ' ' + classes.modalSmallFooterSecondButton}>
              Ja, löschen
            </RegularButton>
          </DialogActions>
        </Dialog>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={applications}
            title="Meine Bewerbungen für Referate und Ämter"
            actions={[
              {
                icon: 'delete',
                tooltip: 'Bewerbung löschen',
                onClick: (event, rowData) => {
                  event.stopPropagation()
                  setApplicationId(rowData.applicationId)
                  setModal(true)
                },
              },
              (rowData) => {
                return !rowData.hasImage
                  ? { hidden: true }
                  : {
                    tooltip: 'Das Bild herunterladen',
                    icon: 'download',
                    hidden: false,
                    onClick: (event, rowData) => {
                      downloadImage(rowData)
                      event.stopPropagation()
                    },
                  }
              },
            ]}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 30, 50],
              headerStyle: {
                fontWeight: 600,
              },
              exportButton: true,
            }}
            localization={{
              pagination: {
                labelDisplayedRows: '{from}-{to} von {count}',
                labelRowsSelect: 'Einträge',
                labelRowsPerPage: 'Zeilen pro Seite',
              },
              toolbar: {
                nRowsSelected: '{0} Zeile(n) ',
                searchPlaceholder: 'Suchen',
                searchTooltip: 'Suchen',
              },
              header: {
                actions: 'Aktion',
              },
              body: {
                emptyDataSourceMessage: 'Keine Bewerbungen',
                filterRow: {
                  filterTooltip: 'Filter',
                },
              },
            }}
          />
        </GridItem>
        <Snackbar
          place="br"
          color={notification.color}
          icon={AddAlert}
          message={notification.message}
          open={notification.open}
          closeNotification={() =>
            setNotification({
              open: false,
              message: '',
              color: '',
            })
          }
          close
        />
      </GridContainer>
    </div>
  )
}
